import { FC } from 'react';

import { Paragraph } from '@common/components/base-app';

import { ProcessLoaderProps } from './ProcessLoader.types';
import { StyledContainer, StyledSectionTitle, StyledSpinnerIcon } from './ProcessLoader.styles';

const ProcessLoader: FC<ProcessLoaderProps> = ({ description, title }) => {
  return (
    <StyledContainer>
      <StyledSectionTitle data-testid="process-loader-title">{title}</StyledSectionTitle>
      <Paragraph data-testid="process-loader-description">{description}</Paragraph>
      <StyledSpinnerIcon data-testid="process-loader-spinner" />
    </StyledContainer>
  );
};

export default ProcessLoader;
